import { combineReducers } from 'redux';
import AccessKeyReducer from './AccessKeyReducer';
import AuthReducers from './AuthReducers';
import ClientManagerReducer from './ClientManagerReducer';
import DashboardReducer from './DashboardReducer';
import KeyManagerReducer from './KeyManagerReducer';
import LogReducers from './LogReducers';
import ReqHistoryReducer from './ReqHistoryReducer';
import RouteManagerReducer from './RouteManagerReducer';
import StaffReducer from './StaffReducer';
import TopupReducer from './TopupReducer';
import ReportsReducer from './ReportsReducer';
import RouteCategoryReducer from './RouteCategoryReducer';

const reducers = combineReducers({
  Auth: AuthReducers,
  ApiKey: KeyManagerReducer,
  Route: RouteManagerReducer,
  Logs: LogReducers,
  Dashboard: DashboardReducer,
  Staff: StaffReducer,
  Topup: TopupReducer,
  Clients: ClientManagerReducer,
  AccessKey: AccessKeyReducer,
  ReqHistory: ReqHistoryReducer,
  Reports: ReportsReducer,
  RouteCategories: RouteCategoryReducer
});

export default reducers;
